import axios from "../../Shared/auth-header";
import { toast } from "react-toastify";
export default {
   GetMembers: async (formData) => {
    let url = `/api/member/SearchMembers`;
    var { data } = await axios.post(url, formData);
    if (data && data.status == "Success") {
      return data;
    } else {
      toast.error(data.message);
      return null;
    }
  }
};
